// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation-root-2K8Jd","ul":"Navigation-ul-2dGcU"};